import PuzzleService from '_services/rest/modules/puzzle-term';

export default {
  state: {
    puzzle: null,
    puzzleList: null,
  },
  mutations: {
    setPuzzleTermList(state, response) {
      state.puzzleList = response;
    },
    setPuzzleTerm(state, puzzle) {
      state.puzzle = puzzle;
    },
  },
  actions: {
    getPuzzleTerm({ commit }, id) {
      PuzzleService.getPuzlleById(id)
        .then(response => {
          commit('setPuzzleTerm', response);
        });
    },
    getPuzzleTermList({ commit }, params) {
      PuzzleService.getPuzlles(params)
        .then(response => {
          commit('setPuzzleTermList', response);
        });
    },
  },
};
